module.exports = __webpack_public_path__ + "img/bg-title.68b8a45b.png";